var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-card',[_c('md-card-header',[_c('span',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.month)+" "+_vm._s(_vm.L('cost')))])]),_c('md-card-content',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.cost,_vm.currency)))]),_c('md-card-actions',[_vm._v(_vm._s(_vm.fromDate)+" ~ "+_vm._s(_vm.toDate))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }